import { useContext } from 'react'

import { DataAggregatorContext } from '@/contexts/DataAggregatorContext'

export const useDataAggregator = () => {
    return useContext(DataAggregatorContext)
}
